import server from '@/services/server'
import transformJson from '@/utils/transformJson'

const state = {
  items: [],
  workshopList: [], // used by autocomplete
  fields: ['vendor', 'serviceProvided', 'address', 'rocNumber', 'bank', 'accountNumber', 'cardNumber', 'pic', 'mobileNumber', 'action']
}

const mutations = {
  SET_DATA: (state, payload) => {
    const keys = Object.keys(payload)
    keys.forEach((key) => {
      state[key] = payload[key]
    })
  }
}

const actions = {
  fetchWorkshops ({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      server.get('/ops/getWorkshopList', params).then((resp) => {
        let items = transformJson(resp.data.msgContent.data, true)
        items = items.sort((a, b) => a.vendor.localeCompare(b.vendor))
        if (params.nameOnly) {
          commit('SET_DATA', { workshopList: items.map(i => i.vendor) })
        } else {
          commit('SET_DATA', { items })
        }
        resolve()
      }).catch((err) => reject(err))
    })
  },
  upsertWorkshop (_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/ops/upsertMRS_Workshop', [payload]).then(() => {
        resolve()
      }).catch((err) => reject(err))
    })
  },
  deleteWorkshop (_, payload) {
    return new Promise((resolve, reject) => {
      server.delete(`/ops/deleteWorkshop/${payload}`).then(() => {
        resolve()
      }).catch((err) => reject(err))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}